<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="background">
        <v-toolbar
          dark
          flat
          color="background"
        >
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click="show = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <LogoImage
          position="center center"
          :contain="false"
          class-name="header-logo-resize"
          image-name="logo-resp.png"
        />
        <DialogNavigation
          class="header-dialog-navigation"
          @close="show = false"
          @logout="$emit('logout')"
        />
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import LogoImage from './LogoImage'
import DialogNavigation from './DialogNavigation'

export default {
  name: 'HeaderDialog',
  components: {
    LogoImage,
    DialogNavigation,
  },
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
</style>
